import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="full-center">
          <div className="card error-card">
            <h2>Algo salió mal</h2>
            <p className="text-secondary">El panel encontró un error inesperado. Recargar suele resolverlo.</p>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>Recargar</button>
            <details>
              <summary>Detalles técnicos</summary>
              <pre>{this.state.error && this.state.error.toString()}</pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
